const ControlsDiagonalsOutsight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.50073 12.8316L6.50073 6.5L12.8341 6.5M6.5043 6.50074L25.5016 25.5M19.1675 25.4948H25.5008V19.1632M25.5007 12.8316V6.5L19.1674 6.5M25.4973 6.50073L6.5 25.5M12.8341 25.4948H6.50077V19.1632"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ControlsDiagonalsOutsight;
